/* @flow */
'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var each = require('async/each');

var whilst = require('async/whilst');

var Errors = require('interface-datastore').Errors;
/* ::
import type {Key, Datastore, Callback, Batch, Query, QueryResult} from 'interface-datastore'
*/

/**
 * A datastore that can combine multiple stores. Puts and deletes
 * will write through to all datastores. Has and get will
 * try each store sequentially. Query will always try the
 * last one first.
 *
 */


var TieredDatastore
/* :: <Value> */
=
/*#__PURE__*/
function () {
  /* :: stores: Array<Datastore<Value>> */
  function TieredDatastore(stores
  /* : Array<Datastore<Value>> */
  ) {
    _classCallCheck(this, TieredDatastore);

    this.stores = stores.slice();
  }

  _createClass(TieredDatastore, [{
    key: "open",
    value: function open(callback
    /* : Callback<void> */
    )
    /* : void */
    {
      each(this.stores, function (store, cb) {
        store.open(cb);
      }, function (err) {
        if (err) {
          return callback(Errors.dbOpenFailedError());
        }

        callback();
      });
    }
  }, {
    key: "put",
    value: function put(key
    /* : Key */
    , value
    /* : Value */
    , callback
    /* : Callback<void> */
    )
    /* : void */
    {
      each(this.stores, function (store, cb) {
        store.put(key, value, cb);
      }, function (err) {
        if (err) {
          return callback(Errors.dbWriteFailedError());
        }

        callback();
      });
    }
  }, {
    key: "get",
    value: function get(key
    /* : Key */
    , callback
    /* : Callback<Value> */
    )
    /* : void */
    {
      var _this = this;

      var storeLength = this.stores.length;
      var done = false;
      var i = 0;
      whilst(function () {
        return !done && i < storeLength;
      }, function (cb) {
        var store = _this.stores[i++];
        store.get(key, function (err, res) {
          if (err == null) {
            done = true;
            return cb(null, res);
          }

          cb();
        });
      }, function (err, res) {
        if (err || !res) {
          return callback(Errors.notFoundError());
        }

        callback(null, res);
      });
    }
  }, {
    key: "has",
    value: function has(key
    /* : Key */
    , callback
    /* : Callback<bool> */
    )
    /* : void */
    {
      var _this2 = this;

      var storeLength = this.stores.length;
      var done = false;
      var i = 0;
      whilst(function () {
        return !done && i < storeLength;
      }, function (cb) {
        var store = _this2.stores[i++];
        store.has(key, function (err, exists) {
          if (err == null) {
            done = true;
            return cb(null, exists);
          }

          cb();
        });
      }, callback);
    }
  }, {
    key: "delete",
    value: function _delete(key
    /* : Key */
    , callback
    /* : Callback<void> */
    )
    /* : void */
    {
      each(this.stores, function (store, cb) {
        store.delete(key, cb);
      }, function (err) {
        if (err) {
          return callback(Errors.dbDeleteFailedError());
        }

        callback();
      });
    }
  }, {
    key: "close",
    value: function close(callback
    /* : Callback<void> */
    )
    /* : void */
    {
      each(this.stores, function (store, cb) {
        store.close(cb);
      }, callback);
    }
  }, {
    key: "batch",
    value: function batch()
    /* : Batch<Value> */
    {
      var batches = this.stores.map(function (store) {
        return store.batch();
      });
      return {
        put: function put(key
        /* : Key */
        , value
        /* : Value */
        )
        /* : void */
        {
          batches.forEach(function (b) {
            return b.put(key, value);
          });
        },
        delete: function _delete(key
        /* : Key */
        )
        /* : void */
        {
          batches.forEach(function (b) {
            return b.delete(key);
          });
        },
        commit: function commit(callback
        /* : Callback<void> */
        )
        /* : void */
        {
          each(batches, function (b, cb) {
            b.commit(cb);
          }, callback);
        }
      };
    }
  }, {
    key: "query",
    value: function query(q
    /* : Query<Value> */
    )
    /* : QueryResult<Value> */
    {
      return this.stores[this.stores.length - 1].query(q);
    }
  }]);

  return TieredDatastore;
}();

module.exports = TieredDatastore;